import styled from 'styled-components';
import { Col, Row } from 'antd';

export const CruiseBrandCard = styled(Col)`
  text-align: center;
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
  width: 132px;
  margin-right: 16px;
`;

export const CruiseBrandCardLarge = styled(Col)`
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  a {
    color: #333;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }
`;

export const CruiseLogo = styled.div`
  width: ${({ expand }: { expand?: boolean }) => (expand ? '200px' : '132px')};
  height: ${({ expand }: { expand?: boolean }) => (expand ? '200px' : '132px')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0px 0px 24px #ddd;
  background-color: white;
  margin-bottom: 16px;
  overflow: hidden;

  font-size: 18px;
  font-family: 'CG-Bold';
  color: #00529b;

  img {
    max-width: ${({ expand }: { expand?: boolean }) =>
      expand ? '80%' : '132px'};
    margin: 0 auto;
  }
`;

export const CruisePartner = styled(Row)`
  padding: 48px 0;
  h3 {
    font-weight: 700;
    color: #00338d;
  }
`;

export const CruisePartnerBG = styled(Col)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const TravelCDCBanner = styled(Row)`
  background-color: #005eaa; /* CDC color */
  padding: 24px 0;
  > .ant-col {
    color: white;
    font-size: 14px;
    border-left: 1px solid #ddd;
    padding-left: 24px;
  }
  a.ant-btn-text {
    align-items: center !important;
    color: white !important;
    display: inline-flex !important;
    float: right !important;
    font-family: 'CG-black' !important;
    font-weight: 900 !important;
    margin-left: 16px !important;
    margin-top: 12px !important;
    padding-right: 0 !important;
  }
`;
